import { decodeBase64, encodeBase64 } from "./base64";

/**
 * IndexWorker ID から Project ID を復元します。
 * ID 形式: IndexWorker:customers/{org}/projects/{project}/index_workers/{indexWorker}
 */
export function toProjectIdFromIndexWorkerId(
  indexWorkerId: string,
): string | null {
  try {
    const decoded = decodeBase64(indexWorkerId);
    if (!isIndexWorkerId(decoded)) return null;
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    if (!orgDb || !projectDb) return null;
    const rawProject = `Project:customers/${orgDb}/projects/${projectDb}`;
    return encodeBase64(rawProject);
  } catch {
    return null;
  }
}

function isIndexWorkerId(decoded: string): boolean {
  // IDの形式: IndexWorker:customers/{org}/projects/{project}/index_workers/{id}
  if (!decoded.startsWith("IndexWorker:customers/")) return false;
  const parts = decoded.split("/");
  return parts[2] === "projects" && parts[4] === "index_workers";
}
